export const SET_GROUP_SUCCESS = "SET_GROUP_SUCCESS";
export const ADD_GROUP_SUCCESS = "ADD_GROUP_SUCCESS";
export const EDIT_GROUP_SUCCESS = "EDIT_GROUP_SUCCESS";
export const DELETE_GROUP_SUCCESS = "DELETE_GROUP_SUCCESS";
